"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowDataContainer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _dataRow = require("./data-row");

var _marked = /*#__PURE__*/_regenerator["default"].mark(rowsIterator),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(columnIterator);

/**
 * @param dataContainer
 * @param sharedRow
 */
function rowsIterator(dataContainer, sharedRow) {
  var numRows, rowIndex;
  return _regenerator["default"].wrap(function rowsIterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          numRows = dataContainer.numRows();
          rowIndex = 0;

        case 2:
          if (!(rowIndex < numRows)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return dataContainer.row(rowIndex, sharedRow);

        case 5:
          ++rowIndex;
          _context.next = 2;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * @param dataContainer
 * @param columnIndex
 */


function columnIterator(dataContainer, columnIndex) {
  var numRows, rowIndex;
  return _regenerator["default"].wrap(function columnIterator$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          numRows = dataContainer.numRows();
          rowIndex = 0;

        case 2:
          if (!(rowIndex < numRows)) {
            _context2.next = 8;
            break;
          }

          _context2.next = 5;
          return dataContainer.valueAt(rowIndex, columnIndex);

        case 5:
          ++rowIndex;
          _context2.next = 2;
          break;

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * A data container where all data is stored internally as a 2D array.
 */


var RowDataContainer = /*#__PURE__*/function () {
  function RowDataContainer(data) {
    var _data$rows$;

    (0, _classCallCheck2["default"])(this, RowDataContainer);
    (0, _defineProperty2["default"])(this, "_rows", void 0);
    (0, _defineProperty2["default"])(this, "_numColumns", void 0);

    if (!data.rows) {
      throw Error('RowDataContainer: no rows provided');
    }

    if (!Array.isArray(data.rows)) {
      throw Error("RowDataContainer: rows object isn't an array");
    }

    this._rows = data.rows;
    this._numColumns = ((_data$rows$ = data.rows[0]) === null || _data$rows$ === void 0 ? void 0 : _data$rows$.length) || 0;
  }

  (0, _createClass2["default"])(RowDataContainer, [{
    key: "numRows",
    value: function numRows() {
      return this._rows.length;
    }
  }, {
    key: "numColumns",
    value: function numColumns() {
      return this._numColumns;
    }
  }, {
    key: "valueAt",
    value: function valueAt(rowIndex, columnIndex) {
      if (this._rows[rowIndex] === null) {
        return null;
      }

      return this._rows[rowIndex][columnIndex];
    }
  }, {
    key: "row",
    value: function row(rowIndex, sharedRow) {
      var tSharedRow = _dataRow.DataRow.createSharedRow(sharedRow);

      if (tSharedRow) {
        tSharedRow.setSource(this, rowIndex);
        return tSharedRow;
      }

      return new _dataRow.DataRow(this, rowIndex);
    }
  }, {
    key: "rowAsArray",
    value: function rowAsArray(rowIndex) {
      return this._rows[rowIndex];
    }
  }, {
    key: "rows",
    value: function rows(sharedRow) {
      var tSharedRow = _dataRow.DataRow.createSharedRow(sharedRow);

      return rowsIterator(this, tSharedRow);
    }
  }, {
    key: "column",
    value: function column(columnIndex) {
      return columnIterator(this, columnIndex);
    }
  }, {
    key: "flattenData",
    value: function flattenData() {
      return this._rows;
    }
  }, {
    key: "getPlainIndex",
    value: function getPlainIndex() {
      return this._rows.map(function (_, i) {
        return i;
      });
    }
  }, {
    key: "map",
    value: function map(func, sharedRow) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tSharedRow = _dataRow.DataRow.createSharedRow(sharedRow);

      var _options$start = options.start,
          start = _options$start === void 0 ? 0 : _options$start,
          _options$end = options.end,
          end = _options$end === void 0 ? this.numRows() : _options$end;
      var endRow = Math.min(this.numRows(), end);
      var out = [];

      for (var rowIndex = start; rowIndex < endRow; ++rowIndex) {
        var _row = this.row(rowIndex, tSharedRow);

        out.push(func(_row, rowIndex));
      }

      return out;
    }
  }, {
    key: "mapIndex",
    value: function mapIndex(func) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$start2 = options.start,
          start = _options$start2 === void 0 ? 0 : _options$start2,
          _options$end2 = options.end,
          end = _options$end2 === void 0 ? this.numRows() : _options$end2;
      var endRow = Math.min(this.numRows(), end);
      var out = [];

      for (var rowIndex = start; rowIndex < endRow; ++rowIndex) {
        out.push(func({
          index: rowIndex
        }, this));
      }

      return out;
    }
  }, {
    key: "find",
    value: function find(func, sharedRow) {
      var tSharedRow = _dataRow.DataRow.createSharedRow(sharedRow);

      for (var rowIndex = 0; rowIndex < this._rows.length; ++rowIndex) {
        var _row2 = this.row(rowIndex, tSharedRow);

        if (func(_row2, rowIndex)) {
          return _row2;
        }
      }

      return undefined;
    }
  }, {
    key: "reduce",
    value: function reduce(func, initialValue, sharedRow) {
      var tSharedRow = _dataRow.DataRow.createSharedRow(sharedRow);

      for (var rowIndex = 0; rowIndex < this._rows.length; ++rowIndex) {
        var _row3 = this.row(rowIndex, tSharedRow);

        initialValue = func(initialValue, _row3, rowIndex);
      }

      return initialValue;
    }
  }]);
  return RowDataContainer;
}();

exports.RowDataContainer = RowDataContainer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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